import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { LoadLocation } from '../redux/api/load/load.model';
import { TwAutocompleteOption } from '../components/TwAutocomplete/TwAutocomplete';
import { getLocationTypeLabel } from '../utils/location/location';

export const useLocationTypeOptions = (
  twLocations: LoadLocation[]
): [TwAutocompleteOption[], Dispatch<SetStateAction<TwAutocompleteOption[]>>] => {
  const [locations, setLocations] = useState<TwAutocompleteOption[]>([]);

  useEffect(() => {
    const locations = [...twLocations];
    const newLocations: TwAutocompleteOption[] = locations.map((l) => ({
      id: l.id,
      label: l.name || '',
      subLabel: l.full_address
        ? l.full_address
        : l.address_1 && l.address_2
        ? `${l.address_1}, ${l.address_2}`
        : l.address_1,
      groupBy: getLocationTypeLabel(l.type),
      value: l || ''
    }));

    setLocations(newLocations);
  }, [twLocations]);

  return [locations, setLocations];
};
